/** @jsxImportSource @emotion/react */

import { DocType, DocumentView } from './DocumentView'

const TermsOfUse = () => {
    return <DocumentView type={DocType.termsOfUse} />
}

export { TermsOfUse }
